export default {
  genderDisclaimer: "/gender-disclaimer",
  termsAndConditions: "/agb",
  privacyPolicy: "/datenschutzerklarung",
  generalGuaranteeConditions: "/abb",
  legalNotice: "/impressum",
  error404: "/404",
  logout: "/abmelden"
};
